import { Node } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    bilibili: {
      setBilibili: (attrs: Record<string, unknown>) => ReturnType;
    };
  }
}

const BilibiliUrlRegexp = /(?:https?:\/\/)?(?:www\.)?(?:bilibili\.com)\/video\/(\w+)/;

const BilibiliEmbedUrl = /(?:https?:\/\/)?(?:player\.bilibili\.com)\/player\.html\?.*bvid=(\w+).*/;

const isBilibiliUrl = (url: string): boolean => BilibiliUrlRegexp.test(url);

const bilibiliToEmbedUrl = (url: string): string | undefined => {
  const match = url.match(BilibiliUrlRegexp);
  if (match) {
    return `https://player.bilibili.com/player.html?bvid=${match[1]}&autoplay=0`;
  }
};

const Bilibili = Node.create({
  name: 'bilibili',
  group: 'block',
  inline: false,
  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      parseSrc: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe',
        getAttrs: (dom) => {
          const src = (dom as HTMLElement).getAttribute('src');
          const match = src?.match(BilibiliEmbedUrl);

          if (match) {
            return {
              src: match[0],
            };
          } else {
            return false;
          }
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const match = HTMLAttributes.src?.match(BilibiliEmbedUrl);

    if (match) {
      HTMLAttributes.src = `https://player.bilibili.com/player.html?bvid=${match[1]}&autoplay=0`;
    }

    return ['iframe', HTMLAttributes];
  },

  addCommands() {
    return {
      setBilibili:
        (attrs) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs,
          });
        },
    };
  },
});

export { Bilibili, isBilibiliUrl, bilibiliToEmbedUrl };
